import React from 'react';
import { NavLink } from 'react-router-dom';

const PageLinks = () => {
  return(
    <ul className="nav">
      <li><NavLink activeClassName='active' exact to='/browse'>Browse</NavLink></li>
      {/*<li><NavLink activeClassName='active' to='/pricing'>Pricing</NavLink></li>
  <li><NavLink activeClassName='active' to='/about'>About</NavLink></li>*/}
    </ul>
  );
}

export default PageLinks;


// WEBPACK FOOTER //
// ./src/components/PageLinks.js